import TestimonialsWrapper from "@/app/parts/testimonials/TestimonialsWrapper";
import React from "react";

interface TestimonialsSectionProps { }

export const TestimonialsSection = (_props: TestimonialsSectionProps): React.FunctionComponentElement<TestimonialsSectionProps> =>
    <TestimonialsWrapper />;
